import { render, staticRenderFns } from "./sumpay.vue?vue&type=template&id=1d2672c4&scoped=true&"
import script from "./sumpay.vue?vue&type=script&lang=js&"
export * from "./sumpay.vue?vue&type=script&lang=js&"
import style0 from "./sumpay.vue?vue&type=style&index=0&id=1d2672c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2672c4",
  null
  
)

export default component.exports